module.exports = __webpack_public_path__ + "3de5cc6e422dd9ded6bfe51165e92f54.webp";